import { de } from './de.ts';

export const texts = de;

/** Ersetzt `{name}`-Platzhalter. */
export function fill(template: string, params: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => (key in params ? String(params[key]) : `{${key}}`));
}
